import { render, staticRenderFns } from "./vertical-nav.vue?vue&type=template&id=fe21bfac"
import script from "./vertical-nav.vue?vue&type=script&lang=js"
export * from "./vertical-nav.vue?vue&type=script&lang=js"
import style0 from "./vertical-nav.vue?vue&type=style&index=0&id=fe21bfac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports